import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import Button from "../../../../../components/buttons/buttons";
// import Card from "../../../../../components/cards/admin/cards";
import Table from "../../../../../components/tables/tableCols1";
import { Pagination } from "../../../../../components/pagination/pagination";
import TableSkeleton from "../../../../../components/skeleton/table";
import CreateWebhookModal from "../../../../../components/modals/admin/createWebhookModal";
import { getOutletFromCookies } from "../../../../../utils/Auth";
import { getMyThirdPartyWebhooks } from "../../../../../redux/thirdPartyWebhook/thirdPartyWebhookActions";

export default function ThirdPartyWebHooks() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const outlet = getOutletFromCookies();

  const { allEmployees, filtering, searching } = useSelector(
    (state) => state.employee
  );
  const { my3PWebhooks } = useSelector((state) => state.thirdPartyWebhook);
  const [data, setData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (outlet?.business_id) {
      dispatch(getMyThirdPartyWebhooks(outlet?.business_id));
    }
    // eslint-disable-next-line
  }, [outlet?.business_id]);

  function createTableData(data) {
    let dataToMap = data;
    if (Array.isArray(dataToMap)) {
      let outputArray = [];
      dataToMap.map((webhook, index) => {
        let single = {
          label: webhook?.label,
          created_at: moment(webhook?.created_at).format("MMM DD YYYY"),
          signature: webhook?.signature,
          url: webhook?.url,
          events_allowed: webhook?.events_allowed?.map((event) => (
            <span>{event}, </span>
          )),
          webhook: webhook,
        };
        outputArray.push({ single });
        return true;
      });
      return outputArray;
    }
  }
  useEffect(() => {
    if (my3PWebhooks?.data) {
      const dataSet = createTableData(my3PWebhooks?.data);
      setData(dataSet);
    }
  }, [my3PWebhooks]);

  function closeModal() {
    setIsOpen(false);
  }

  function openModal() {
    setIsOpen(true);
  }

  function goToSinglePage(params) {
    let webhook = params?.single?.webhook;
    let webhook_id = webhook?.id;
    navigate(
      `/admin/${
        outlet?.store_name || outlet?.restaurant_name
      }/settings/third-party-webhooks/${webhook_id}`,
      {
        state: { webhook },
      }
    );
  }

  const columns = useMemo(
    () => [
      {
        Header: "",
        hideHeader: false,
        id: "checkbox-table-column",
        // First group columns
        columns: [
          {
            Header: "Label",
            accessor: "single.label",
          },
          {
            Header: "Created",
            accessor: "single.created_at",
          },
          {
            Header: "Signature",
            accessor: "single.signature",
          },
          {
            Header: "Url",
            accessor: "single.url",
          },
          {
            Header: "Events Allowed",
            accessor: "single.events_allowed",
          },
        ],
      },
    ],
    []
  );
  return (
    <div className="all-employees">
      <div className="bg-white dark:bg-[#121212] rounded-sm px-4 sm:px-8 py-5">
        <div className="flex justify-between">
          <p className=" text-sm font-bold text-gray-500 dark:text-[#BCBCBC] sm:max-w-[500px]">
            This allows a third party to receive status updates on orders for
            your company using the supplied URL. See the documentation for
            clarity
          </p>
          <div className="hidden sm:block">
            <Button.Primary title={" + Create Web Hook"} onClick={openModal} />
          </div>
        </div>
      </div>

      <div className="border-b border-[#E4E4F3]"></div>
      <div className="bg-white dark:bg-[#121212] rounded-md py-4">
        {searching || filtering ? (
          <TableSkeleton />
        ) : data?.length > 0 ? (
          <Table
            columns={columns}
            data={data?.length > 0 ? data : []}
            onClick={goToSinglePage}
            className="w-full"
            rowClass="hover:shadow-md cursor-pointer"
          />
        ) : (
          <div className="text-center">
            <p className="font-bold text-xl my-3">Third Party Webhooks</p>
            <p className="text-sm text-gray-500">
              You do not have any third party webhooks yet
            </p>
          </div>
        )}
        <Pagination
          data={allEmployees}
          route={`admin/${
            outlet?.store_name || outlet?.restaurant_name
          }/employees/all`}
        />

        <CreateWebhookModal show={isOpen} onClose={closeModal} />
      </div>
    </div>
  );
}
